// Default React, Router and Services Components
import React, { useState } from "react";
import { Breadcrumbs, Box, Grid, Paper, Typography, Button } from "@mui/material";
import ApiService from "../../../../Services/ApiService";
import { toast } from "react-toastify";
import { Link } from 'react-router-dom';
import ErroHandling from "../../../../Services/ErrorHandling";
import { toasterError } from "../../../../UIComponent/Toaster";
// Importing Custom Components
import BaseLayout from "../../../../UIComponent/BaseLayout";
import DataTable from "../../../../UIComponent/DataTable";
import DatePicker from "../../../../UIComponent/DatePicker";
import XLSX from "sheetjs-style";
import * as FileSaver from "file-saver";

// Importing useStyles
import useStyles from "./WeeklyStatusReport.styles";

// Import Fluent UI Icons
import { ChevronRightSmallIcon, ExportIcon } from "@fluentui/react-icons-mdl2";

const DataCollectionWeeklyStatusReport = (props) => {
    // Declaration of States and Component Variables Start Here
    const [allWeeklyReports, setWeeklyReports] = useState([]);
    const classes = useStyles();
    const [totalCount, setTotalCount] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [sorting, setSorting] = useState({ sortBy: "", isAscending: false });
    const [selected, SetSelected] = useState([]);
    const [isAllSelected, setIsSelected] = useState(false);
    const [reload, setReload] = useState(false);
    const [value, setValue] = useState({ startDate: '', endDate: '', });
    // Declaration of States and Component Variables End Here

    // Declaration of React Hooks Start Here
    React.useEffect(() => {
        if (value.startDate != '' && value.endDate != '') getAllWeeklyStatusReports();
    }, [page, reload, rowsPerPage, sorting])

    React.useEffect(() => {
        if (value.startDate != '' && value.endDate != '') getAllWeeklyStatusReports();
    }, [value.startDate, value.endDate])
    // Declaration of React Hooks End Here

    // Assigning Columns and UI Props
    const columns = [
        { id: "Id", label: "Id", type: "Highlight" },
        { id: "jobName", label: "JobName", minWidth: 300, width: 300, sorting: true },
        { id: "totalNoOfAssets", label: "Total Assets", minWidth: 100, width: 'auto', sorting: true, align: "center" },
        { id: "totalNoOfAssetsCompleted", label: "Assets Completed ", minWidth: 120, width: 'auto', sorting: true, align: "center" },
        { id: "totalNoOfAssetsPending", label: "Assets Pending", minWidth: 100, width: 'auto', sorting: true, align: "center" },
        { id: "nameOfProductionAnalyst", label: "Analysts Deployed (Production)", minWidth: 230, width: 'auto', sorting: true },
        { id: "nameOfQCAnalyst", label: "Analysts Deployed (QC)", minWidth: 150, width: 'auto', sorting: true, },
        { id: "productionHours", label: "Production Hours", minWidth: 110, width: 'auto', sorting: true, align: "center" },
        { id: "qcHours", label: "QC Hours", minWidth: 100, width: 'auto', sorting: true, align: "center" },
        { id: "averageTimeTakenPerAssets", label: "Avg Time Taken per asset", minWidth: 150, width: 'auto', sorting: true, align: "center" },
        { id: "ragStatus", label: "RAG Status", minWidth: 90, width: 'auto', sorting: true, type: "Chip", align: "center" },
        { id: "jobStartDate", label: "Job Start Date", minWidth: 110, width: 'auto', sorting: true, align: "center" },
        { id: "jobEndDate", label: "Job End Date", minWidth: 110, width: 'auto', sorting: true, align: "center" },
    ];

    // Function for Validation
    const date = "2022-11-25T21:11:54";
    const validation = (value) => {
        if (value.startDate >= value.endDate) {
            toasterError("To Date Must Be Greater");
            return false;
        }
        return true;
    }
   
    //Function to get all weekly status reports
const getAllWeeklyStatusReports = () => {
    //Validate the value
    if (validation(value)) {
        let sortingColumn = '';
            //Check if sorting is by ragStatus
            if (sorting.sortBy == 'ragStatus'){
                sortingColumn = 'RAGStatus'
            }
            //Check if sorting is by qcHours
            else if (sorting.sortBy == 'qcHours'){
                sortingColumn = 'QCHours'
            }
            //Else set sorting column
            else{
                sortingColumn = sorting.sortBy.slice(0,1).toUpperCase()+sorting.sortBy.slice(1,sorting.sortBy.length)
            }
        //Set loading to true
        setLoading(true);
        let prt = [`pageNumber=${page + 1}`, `pageSize=${rowsPerPage}`];
        //Call ApiService to search for reports
        ApiService.search("reports/GetWeeklyStatusReportForCompanyOwnershipChanges?",
            {
                isAscending: sorting.isAscending,
                sortColumn: sortingColumn,
                startDate: value.startDate.split('-').reverse().join('-'),
                endDate: value.endDate.split('-').reverse().join('-')
            }, prt
        ).then((res) => {
            //If response is successful
            if (res.status === 200) {
                //Check if data is not null
                if (res.data.data != null) {
                    //Map through the data and format the productionHours, qcHours and averageTimeTakenPerAssets
                    let newData = res.data.data.map((e) => {
                        if (e.productionHours !== null && e.productionHours !== undefined && e.productionHours !== '') {
                            let tempProductionHours = e.productionHours;
                            let splitedValue = tempProductionHours.split(':');
                            let tempNewsplitedValue = splitedValue.map((el) => { return formatNumber(el) });
                            tempProductionHours = tempNewsplitedValue.join(':');
                            e.productionHours = tempProductionHours;
                        }
                        if (e.qcHours !== null && e.qcHours !== undefined && e.qcHours !== '') {
                            let tempQcHours = e.qcHours;
                            let splitedValue = tempQcHours.split(':');
                            let tempNewsplitedValue = splitedValue.map((el) => { return formatNumber(el) });
                            tempQcHours = tempNewsplitedValue.join(':');
                            e.qcHours = tempQcHours;
                        }
                        if (e.averageTimeTakenPerAssets !== null && e.averageTimeTakenPerAssets !== undefined && e.averageTimeTakenPerAssets !== '') {
                            let tempAverageTimeTakenPerAssets = e.averageTimeTakenPerAssets;
                            let splitedValue = tempAverageTimeTakenPerAssets.split(':');
                            let tempNewsplitedValue = splitedValue.map((el) => { return formatNumber(el) });
                            tempAverageTimeTakenPerAssets = tempNewsplitedValue.join(':');
                            e.averageTimeTakenPerAssets = tempAverageTimeTakenPerAssets;
                        }
                        return e;
                    })
                    //Set weekly reports with new data
                    setWeeklyReports(newData);
                } else {
                    //Else set weekly reports with existing data
                    setWeeklyReports(res.data.data);
                }

                //Set total count
                setTotalCount(res.data.totalCount);
                //Set loading to false
                setLoading(false);
            } else {
                //Else show error message
                toasterError(`${res.data}`);
                setLoading(false);
            }
        })
            .catch((err) => {
                //Handle errors
                ErroHandling(err, function (res) {
                    toasterError(res)
                })
                setLoading(false);
            });
    }
    else {
        //Else set loading to false
        setLoading(false)
    }
}

   // This function takes a number as an argument and returns a formatted version of the number
    // The formatted version is a string with two digits, padded with a 0 if necessary
    const formatNumber = (number) => {
        // Convert the number to a string and pad it with a 0 if necessary
        let formattedNumber = String(number).padStart(2, '0')
        return formattedNumber;
    }

    //Function to export to excel file
    const handleExportToExcel = async () => {
        try {
            //Validate the value
            if (validation(value)) {
                let sortingColumn = '';
                //Check if sorting is by ragStatus
                if (sorting.sortBy == 'ragStatus'){
                    sortingColumn = 'RAGStatus'
                }
                else{
                    //Capitalize the first letter of sortBy
                    sortingColumn = sorting.sortBy.slice(0,1).toUpperCase()+sorting.sortBy.slice(1,sorting.sortBy.length)
                }
                //Set pageNumber and pageSize
                let prt = [`pageNumber=1`, `pageSize=${totalCount}`];
                //Call ApiService to search for data
                ApiService.search("reports/GetWeeklyStatusReportForCompanyOwnershipChanges?",
                    {
                        isAscending: sorting.isAscending,
                        sortColumn: sortingColumn,
                        startDate: value.startDate.split('-').reverse().join('-'),
                        endDate: value.endDate.split('-').reverse().join('-')
                    }, prt
                ).then((res) => {
                    let excelData = [];
                    //Loop through response data and push into excelData array
                    res.data.data.forEach((obj, index) => {
                        let tempData = {
                            "JobName": obj.jobName,
                            "Total Asset": obj.totalNoOfAssets,
                            "Assets Compeleted": obj.totalNoOfAssetsCompleted,
                            "Assets Pending": obj.totalNoOfAssetsPending,
                            "Analysts Deployed (Production)": obj.nameOfProductionAnalyst,
                            "Analysts Deployed (QC)": obj.nameOfQCAnalyst,
                            "Production Hours": obj.productionHours,
                            "QC Hours": obj.qcHours,
                            "Avg Time Taken per asset": obj.averageTimeTakenPerAssets,
                            "RAG Status": obj.ragStatus,
                            "Job Start Date": obj.jobStartDate,
                            "Job End Date": obj.jobEndDate
                        }
                        excelData.push(tempData);
                    });
                    //Set file name
                    const fileName = `Weekly Status Report ${new Date()
                        .toLocaleDateString()
                        .split("/")
                        .join("-")}`;
                    //Call exportToCSV function to export data to CSV
                    exportToCSV(excelData, fileName)

                });

            }
        } catch (error) {
            //Handle error
            ErroHandling(error, function (res) {
                toasterError(res)
            })
        }
    }

    // This function is used to export data from an API to a CSV file
const exportToCSV = (apiData, fileName) => {
    // Set the file type and extension
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    // Convert the API data to a worksheet
    const ws = XLSX.utils.json_to_sheet(apiData);
    // Add the column headers to the worksheet
    XLSX.utils.sheet_add_aoa(
        ws,
        [[
            "JobName",
            "Total Asset",
            "Assets Compeleted",
            "Assets Pending",
            "Analysts Deployed (Production)",
            "Analysts Deployed (QC)",
            "Production Hours",
            "QC Hours",
            "Avg Time Taken per asset",
            "RAG Status",
            "Job Start Date",
            "Job End Date"

        ],],
        { origin: "A1", }
    );
    // Create the workbook object
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    // Write the workbook object to a buffer
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    // Create a blob from the buffer
    const data = new Blob([excelBuffer], { type: fileType });
    // Save the blob as a file
    FileSaver.saveAs(data, fileName + fileExtension);
};
   
    return (
        // Page Layout Start Here
        <Box>
            <Grid container maxWidth justifyContent="right" alignItems="center">

                {/* Breadcrumbs Menu Start Here */}
                <Grid item xs={12} sm={12} md={9} className="page-title">
                    <h2>Weekly Status Report</h2>
                    <Breadcrumbs
                        separator={<ChevronRightSmallIcon className={classes.breadCrumbsIcon} />} aria-label="breadcrumb" className="custom-breadcrumb">
                        <Link underline="hover" color="inherit" to={{ pathname: "/app/ownership-changes/source-management" }}>Home</Link>
                        <Typography color="text.primary">Manage Company Ownership Changes</Typography>
                        <Link underline="hover" color="inherit" to={{ pathname: "/app/ownership-changes/aging-report" }}>Dashboard and Reports</Link>
                        <Typography color="text.primary">Weekly Status Report</Typography>
                    </Breadcrumbs>
                </Grid>
                {/* Breadcrumbs Menu End Here */}

                {/* Main Buttons Start Here */}
                <Grid item xs={12} sm={12} md={3}>
                    <Grid container spacing={2} justifyContent="flex-end" alignItems="center">
                        <Grid item xs={"auto"}>

                        </Grid>
                    </Grid>
                </Grid>
                {/* Main Buttons End Here */}

                {/* Baselayout Start Here */}
                <Grid item xs={12}>
                    <BaseLayout>
                        <Box className={classes.addBorder}>

                            {/* Search and Filter Options Start Here */}
                            <Grid item xs={12} className={classes.tableTopPart}>
                                <Grid container alignItems="flex-end" justifyContent="left" spacing={2}>
                                    <Grid item xs={12} lg={9}>
                                        <Grid container spacing={3} justifyContent="flex-start" alignItems="flex-end">
                                            <Grid item xs={"auto"}>
                                                <DatePicker
                                                    labelTitle="From Date"
                                                    variant="standard"
                                                    past={false}
                                                    onChangeDate={(e) => {
                                                        let selectedDate = new Date(e);
                                                        let date = selectedDate.getFullYear() + '-' + ("0" + (selectedDate.getMonth() + 1)).slice(-2) + '-' + ("0" + (selectedDate.getDate())).slice(-2)
                                                        setValue({ ...value, startDate: date })
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={"auto"}>
                                                <DatePicker
                                                    labelTitle="To Date"
                                                    variant="standard"
                                                    past={false}
                                                    minDates={value.startDate}
                                                    onChangeDate={(e) => {
                                                        let selectedDate = new Date(e);
                                                        let date = selectedDate.getFullYear() + '-' + ("0" + (selectedDate.getMonth() + 1)).slice(-2) + '-' + ("0" + (selectedDate.getDate())).slice(-2)
                                                        setValue({ ...value, endDate: date })
                                                    }}
                                                />
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} lg={3} textAlign="right">
                                        <Grid container spacing={3} justifyContent="flex-end" alignItems="flex-end">
                                            <Grid item xs={"auto"}>
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    startIcon={<ExportIcon style={{ fontSize: 14 }} />}
                                                    onClick={handleExportToExcel}

                                                >
                                                    Export To Excel
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* Search and Filter Options End Here */}



                            {/* Weekly Status Report Table */}
                            <Grid item xs={12}>
                                <DataTable
                                    className={classes.removeBorder}
                                    loading={isLoading}
                                    rows={allWeeklyReports ? allWeeklyReports : []}
                                    columns={columns}
                                    page={page}
                                    setPage={(data) => {
                                        setPage(data);
                                        setReload(true);
                                    }}
                                    rowsPerPage={rowsPerPage}
                                    setRowsPerPage={(data) => {
                                        setRowsPerPage(data);
                                        setReload(true);
                                    }}
                                    totalCount={totalCount}
                                    isAllSelected={isAllSelected}
                                    setIsSelected={setIsSelected}
                                    selected={selected}
                                    setSelected={SetSelected}
                                    sorting={sorting}
                                    setSorting={setSorting}
                                    hasChip={{
                                        Red: { color: "error", label: "Red" },
                                        Green: { color: "success", label: "Green" },
                                        Amber: { color: "warning", label: "Amber" },
                                    }}
                                />
                            </Grid>
                        </Box>
                    </BaseLayout>
                </Grid>
            </Grid>
        </Box>
    )
}


export default DataCollectionWeeklyStatusReport;